import { yupResolver } from '@hookform/resolvers/yup';
import { Form, message } from 'antd';
import { PrimaryButton } from 'components/button';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ClaimTabs } from 'components/claimTab/ClaimTab';
import { PreClaimTitle } from './components/PreClaimTitle';
import PreClaimInfoCard from './cards/PreClaimInfoCard';
import DocumentsCard from './cards/DocumentsCard';
import { getPreClaimSchema, PreClaimFormState } from './schema';
import { ApiFetcherError, /*useEnquiryEmailSubmission, */ usePreAuthEnquiry } from 'all-in-one-shared-api';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { HomeContext } from 'contexts/home/context';
import { useNavigate } from 'react-router-dom';
import { EnquirySubmissionResponse } from 'all-in-one-shared-api/dist/apis/enquiry/types';
import { PreClaimRequestSubmitted } from './PreClaimRequestSubmitted';
import { toDateString } from 'utils';
import { uploadFiles } from 'api/uploadEnquiryDocument';
import { MessageType } from 'models/MessageType';
import { RcFile } from 'antd/es/upload';
import { revalidateReactFormHook } from '../../i18n';
import { useClaimPropertiesContext } from 'contexts/claimProperties';
import { useCachedClaimProperties } from 'hooks';

const { Item: FormItem } = Form;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px;
  row-gap: 32px;
  column-gap: 18px;

  .ant-form-item-required::before {
    display: none !important;
  }
`;

const FromWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

const PreClaimPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const { state: homeState } = useContext(HomeContext);
  const { key: claimPropertiesKey } = useClaimPropertiesContext();
  const { data: claimProperties } = useCachedClaimProperties(claimPropertiesKey);

  const methods = useForm<PreClaimFormState>({
    resolver: yupResolver(getPreClaimSchema(t)),
  });

  useEffect(() => {
    revalidateReactFormHook(methods);
  }, [i18n.language, methods]);

  const selectedMember =
    claimProperties?.familyMembers?.find((member) => member?.memberType === methods.getValues('patientName')) ?? {};
  const selectedMemberName = `${selectedMember.firstName} ${selectedMember.lastName}` ?? '';

  const { token } = useKeycloakReady();
  const keyCloakToken = token ?? '';

  const [enquiryReference, setEnquiryReference] = useState<string>('');
  const [attachments, setAttachments] = useState<RcFile[]>();
  const [finished, setFinished] = useState<boolean>(false);

  // const { shouldFetch: shouldPostEnquiryEmailSubmission } = useEnquiryEmailSubmission(
  //   { name: 'enquiryEmailSubmission', enquiryReference },
  //   keyCloakToken,
  //   enquiryReference,
  //   {
  //     revalidateOnFocus: false,
  //   },
  // );

  const {
    shouldFetch: shouldPostEnquirySubmission,
    data: enquirySubmissionResponse,
    error: enquirySubmissionError,
  } = usePreAuthEnquiry(
    {
      name: 'preAuthSubmission',
      patientName: selectedMemberName,
      admissionDate: toDateString(methods.getValues('admissionDate')),
      hospital: methods.getValues('hospital'),
      doctor: methods.getValues('doctor'),
      diagnosis: methods.getValues('diagnosis'),
      surgery: methods.getValues('surgery'),
      patientMemberType: methods.getValues('patientName'),
      uploadFlag:
        methods.getValues('admissionOrReferralLetters') && methods.getValues('admissionOrReferralLetters').length > 0
          ? true
          : false,
    },
    keyCloakToken,
    {
      patientName: selectedMemberName,
      admissionDate: toDateString(methods.getValues('admissionDate')),
      hospital: methods.getValues('hospital'),
      doctor: methods.getValues('doctor'),
      diagnosis: methods.getValues('diagnosis'),
      surgery: methods.getValues('surgery'),
      patientMemberType: methods.getValues('patientName'),
      uploadFlag:
        methods.getValues('admissionOrReferralLetters') && methods.getValues('admissionOrReferralLetters').length > 0
          ? true
          : false,
    },
    {
      shouldRetryOnError: false,
    },
  );

  useEffect(() => {
    if (!homeState.userAccess?.hasHOSP) {
      navigate('/claims');
    }
  }, [homeState, navigate]);

  // const finaliseEnquirySubmission = useCallback(() => {
  //   // shouldPostEnquiryEmailSubmission(true);
  //   setFinished(true);
  // }, [setFinished]);

  /* eslint-disable */
  const processUploadAttachments = useCallback(() => {
    if (!enquiryReference) {
      return;
    }
    if (!attachments?.length) {
      // finaliseEnquirySubmission();
      setFinished(true);
      return;
    }
    // console.log('333333333333333333333333333333333333333333333');
    uploadFiles({
      accessToken: keyCloakToken,
      params: {
        //Note Thuy's: please be aware of `fileList` returned by antd
        documents: attachments,
        referenceNo: enquiryReference,
        enquiryFlag: 'CREDITFLAG',
      },
    })
      .then(() => {
        // finaliseEnquirySubmission();
        setFinished(true);
        // console.log('55555555555555555555555555555555555');
      })
      .catch(() => {
        message[MessageType.ERROR](t('common.error.generic'));
      });
  }, [attachments, enquiryReference, t]);

  useEffect(() => {
    // console.log('res1111111111111111111111111111111111111111111111');
    processUploadAttachments();
    // console.log('22222222222222222222222222222222222222222222222');
    // return () => shouldPostEnquiryEmailSubmission(false);
  }, [attachments, processUploadAttachments]);

  const continueAfterPostEnquiry = useCallback(
    (response: EnquirySubmissionResponse | undefined, error: ApiFetcherError | undefined) => {
      if (error) {
        console.log('ApiFetcherError', error);
        setFinished(true);
      }

      if (response) {
        const enquiryReference: string = response.message;
        setEnquiryReference(enquiryReference);

        setAttachments(methods.getValues('admissionOrReferralLetters'));
      }
    },
    [methods],
  );

  useEffect(() => {
    if (enquirySubmissionResponse || enquirySubmissionError) {
      shouldPostEnquirySubmission(false);
      continueAfterPostEnquiry(enquirySubmissionResponse, enquirySubmissionError);
    }
  }, [enquirySubmissionResponse, enquirySubmissionError, continueAfterPostEnquiry, shouldPostEnquirySubmission]);

  const handleSubmitEnquiry = () => {
    shouldPostEnquirySubmission(true);
  };

  const claimTabs = [
    { translationKey: 'preAuthRequest.requestInformation.title', key: 'requestInformation' },
    { translationKey: 'preAuthRequest.supplementaryDocuments.title', key: 'documents' },
  ];

  if (finished) {
    return <PreClaimRequestSubmitted enquiryReference={enquiryReference} />;
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmitEnquiry)}>
        <Wrapper>
          <PreClaimTitle />
          <>
            <FromWrapper>
              <PreClaimInfoCard />
              <DocumentsCard stepIndex={1} />
              <FormItem>
                <PrimaryButton htmlType="submit">{t('preAuthRequest.submit')}</PrimaryButton>
              </FormItem>
            </FromWrapper>
            <ClaimTabs claimTabs={claimTabs} />
          </>
        </Wrapper>
      </form>
    </FormProvider>
  );
};

export default PreClaimPage;
